import * as React from 'react';
import type { SVGProps } from 'react';
const SvgRefresh = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill="#A5A5AA"
      fillRule="evenodd"
      d="M12.333 3C9.255 3 6.951 4.287 5.435 5.552c-.2.166-.387.333-.56.497V4.777a.937.937 0 1 0-1.875 0v3.828c0 .518.42.938.938.938h3.727a.937.937 0 1 0 0-1.875H5.901c.215-.219.46-.448.735-.677 1.282-1.069 3.175-2.116 5.697-2.116a7.44 7.44 0 0 1 7.458 7.458 7.46 7.46 0 0 1-5.556 7.212.938.938 0 0 0 .478 1.813c4.002-1.054 6.953-4.693 6.953-9.025A9.315 9.315 0 0 0 12.333 3Zm-7.458 9.333a.937.937 0 1 0-1.875 0c0 .622.061 1.23.178 1.82a.938.938 0 1 0 1.84-.364 7.487 7.487 0 0 1-.143-1.456Zm1.256 4.142a.938.938 0 0 0-1.557 1.044 9.385 9.385 0 0 0 2.573 2.573.937.937 0 1 0 1.044-1.557 7.512 7.512 0 0 1-2.06-2.06Zm4.746 3.174a.938.938 0 0 0-.365 1.84c.59.116 1.199.177 1.821.177a.938.938 0 0 0 0-1.875c-.5 0-.986-.049-1.456-.142Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgRefresh;
